import indiaLocationsData from './indiaLocations.json';

export const INDIA_LOCATIONS = indiaLocationsData;

export const FALLBACK_STATES = Object.keys(indiaLocationsData).sort();

export const FALLBACK_CITIES = indiaLocationsData;

export async function fetchStates() {
  return FALLBACK_STATES;
}

export async function fetchCitiesForState(stateName) {
  if (!stateName) return [];
  
  // Try exact match
  if (indiaLocationsData[stateName]) {
    return indiaLocationsData[stateName];
  }
  
  // Try case-insensitive match
  const matchedKey = Object.keys(indiaLocationsData).find(
    k => k.toLowerCase().trim() === stateName.toLowerCase().trim()
  );
  
  if (matchedKey && indiaLocationsData[matchedKey]) {
    return indiaLocationsData[matchedKey];
  }

  return [];
}

